import axios from "axios";
import { useDispatch } from "react-redux";
/** Services Import */
import Global from "./Global";
import IndexedDb from "../IndexedDb/IndexedDb";
import _ from "lodash";
import { format } from "date-fns";
import CryptoJS from "crypto-js";
import { LocalStorageActions } from "../../Redux-Reducer/LocalStorageReducer";

// Axios 인터셉터 설정
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const dispatch = useDispatch();
    // 401 에러(인증 실패) 발생 시
    if (error.response?.status === 401) {
      // IndexedDB의 사용자 정보 삭제
      await IndexedDb.ClearTable("UserInfo");
      dispatch(LocalStorageActions.setAuthorization({ authorization: false, authDate: "", authType: "" }));
      Commons.Storages("set", "userInfo", {
        userId: "",
        userName: "",
      });
      // 메인 페이지로 이동
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

const Commons = {
  // 현재 화면의 너비와 높이 반환 함수
  Dimentions: () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  },

  // 모바일인지 Check, mobile => true
  IsMobile: () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  },

  // String change function
  ChangeString: (_data, _type = "trim") => {
    if (_data.lenght < 1) {
      return "";
    }

    const data = _data.toString();

    switch (_type) {
      case "trim":
        return data.trim();
      case "lTrim":
        return data.trimStart();
      case "rTrim":
        return data.trimEnd();
      case "toInt":
        if (!parseInt(data)) {
          return 0;
        } else {
          return parseInt(data);
        }
      case "toFloat":
        if (!parseFloat(data)) {
          return 0;
        } else {
          return parseFloat(data);
        }
      case "upper":
        return data.toUpperCase();
      case "lower":
        return data.toLowerCase();
    }
  },

  // Grid insert rows number
  InsertNumber: (_arr = []) => {
    let newArr = [];
    if (_arr.length > 0) {
      _arr.forEach((item, index) => {
        newArr.push({
          ...item,
          no: index + 1,
        });
      });

      return newArr;
    } else {
      return false;
    }
  },

  // 칼럼 'i' 기준으로 중복 제거
  Deduplication: (_arr = []) => {
    let result = _arr.reverse().filter((item, index) => {
      return (
        _arr.findIndex((item1, index1) => {
          return item.i === item1.i;
        }) == index
      );
    });

    return result.reverse();
  },

  // SHA256 암호화 함수
  Sha256Encrypt: (text) => {
    const hash = CryptoJS.SHA256(text);
    return CryptoJS.enc.Base64.stringify(hash);
  },

  // AES256 암호화 함수
  EncryptAES: (_text) => {
    const cipher = CryptoJS.AES.encrypt(_text, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY.padEnd(32, " ")), {
      iv: CryptoJS.enc.Utf8.parse(""),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    return cipher.toString();
  },

  // AES256 복호화 함수
  DecryptoAES: (_text) => {
    const cipher = CryptoJS.AES.decrypt(_text, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY.padEnd(32, " ")), {
      iv: CryptoJS.enc.Utf8.parse(""),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    return cipher.toString(CryptoJS.enc.Utf8);
  },

  // Date 포멧을 바꾸는 function
  DateFormating: (_date, _type = 1) => {
    var dateString = null;
    if (_date && _date.length < 9) {
      const tdata = new Date();
      let tyear = tdata.getFullYear();
      let tmonth = tdata.getMonth() + 1;
      let tday = tdata.getDate();
      let thour = tdata.getHours();
      let tmin = tdata.getMinutes();
      let tsec = tdata.getSeconds();
      if (_date.length == 8) {
        tyear = _date.substring(0, 4);
        tmonth = _date.substring(4, 6);
        tday = _date.substring(6, 8);
        dateString = new Date(tyear, tmonth - 1, tday);
      } else if (_date.length == 6) {
        thour = _date.substring(0, 2);
        tmin = _date.substring(2, 4);
        tsec = _date.substring(4, 6);
        dateString = new Date(tyear, tmonth - 1, tday, thour, tmin, tsec);
      } else {
        return "";
      }
    } else if (!_date) {
      return "";
    }

    const data = dateString != null && dateString != "Invalid Date" ? dateString : new Date(_date);
    let year = data.getFullYear();
    let month = data.getMonth() + 1;
    let date = data.getDate();
    let hour = data.getHours();
    let min = data.getMinutes();
    let sec = data.getSeconds();

    switch (_type) {
      case 0:
        return data;
      case 1:
        return (
          year +
          "-" +
          month.toString().padStart(2, "0") +
          "-" +
          date.toString().padStart(2, "0") +
          " " +
          hour.toString().padStart(2, "0") +
          ":" +
          min.toString().padStart(2, "0") +
          ":" +
          sec.toString().padStart(2, "0")
        );
      case 2:
        return year + "-" + month.toString().padStart(2, "0") + "-" + date.toString().padStart(2, "0");
      case 22:
        return month.toString().padStart(2, "0") + "-" + date.toString().padStart(2, "0");
      case 3:
        return (
          year +
          "/" +
          month.toString().padStart(2, "0") +
          "/" +
          date.toString().padStart(2, "0") +
          "/ " +
          hour.toString().padStart(2, "0") +
          ":" +
          min.toString().padStart(2, "0") +
          ":" +
          sec.toString().padStart(2, "0")
        );
      case 4:
        return year + "/" + month.toString().padStart(2, "0") + "/" + date.toString().padStart(2, "0");
      case 44:
        return month.toString().padStart(2, "0") + "/" + date.toString().padStart(2, "0");
      case 5:
        return (
          year.toString() + month.toString().padStart(2, "0") + date.toString().padStart(2, "0") + hour.toString().padStart(2, "0") + min.toString().padStart(2, "0") + sec.toString().padStart(2, "0")
        );
      case 6: //년월일
        return year.toString() + month.toString().padStart(2, "0") + date.toString().padStart(2, "0");
      case 7: //시분초
        return hour.toString().padStart(2, "0") + min.toString().padStart(2, "0") + sec.toString().padStart(2, "0");
      case 77: //시분초
        return `${hour.toString().padStart(2, "0")}:${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
      case 8: //년월
        return year.toString() + month.toString().padStart(2, "0");
      case 88: //년/월
        return `${year.toString()}/${month.toString().padStart(2, "0")}`;
      case 9: //년
        return year.toString();
      case 99: //시분
        return `${hour.toString().padStart(2, "0")}:${min.toString().padStart(2, "0")}`;
    }
  },

  // 입력된 숫자를 무조건 'YYYY-MM-DD' 포맷으로 변환
  InputDateFormating: (_param) => {
    // 숫자와 하이픈만 허용
    const cleaned = _param.replace(/[^\d-]/g, "");

    // 하이픈 제거 후 숫자만 추출
    const numbers = cleaned.replace(/-/g, "");

    // 8자리 이상이면 8자리까지만 사용
    const limitedNumbers = numbers.slice(0, 8);

    // YYYY-MM-DD 포맷으로 변환
    if (limitedNumbers.length >= 4) {
      const year = limitedNumbers.slice(0, 4);
      const month = limitedNumbers.slice(4, 6);
      const day = limitedNumbers.slice(6, 8);

      let formatted = year;
      if (month) {
        formatted += `-${month}`;
        if (day) {
          formatted += `-${day}`;
        }
      }
      return formatted;
    }

    return limitedNumbers;
  },

  // 전화번호 포맷팅
  FormatPhoneNumber: (value, previousValue = "") => {
    if (!value) return value;

    // 이전 값과 비교하여 값이 줄어들고 있는지 확인
    const currentDigits = value.replace(/[^\d]/g, "");
    const previousDigits = previousValue.replace(/[^\d]/g, "");

    // 현재 값의 길이가 이전 값보다 짧으면 삭제 중
    if (value.length < previousValue.length) {
      return value;
    }

    // 숫자가 줄어들고 있으면 포맷팅을 적용하지 않음
    if (currentDigits.length < previousDigits.length) {
      return value;
    }

    // 입력값에서 모든 -를 제거한 후 숫자만 추출
    const phoneNumber = value.replace(/-/g, "").replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
  },

  // Local Storage get/set/remove/clear return function
  Storages: (_type, _name, _data) => {
    switch (_type) {
      case "get":
        if (_name) {
          return JSON.parse(window.localStorage.getItem(_name));
        } else {
          return "error";
        }
      case "set":
        if (_name && _data) {
          window.localStorage.setItem(_name, JSON.stringify(_data));
          break;
        } else {
          return "error";
        }
      case "remove":
        if (_name) {
          window.localStorage.removeItem(_name);
          break;
        } else {
          return "error";
        }
      case "clear":
        window.localStorage.clear();
        break;
    }
  },

  //Axios get/post response function
  Axios: async (_type = "get", _url, _params, _bodys = null) => {
    let token = null;
    let userId = null;
    await IndexedDb.GetUserInfo().then((result) => {
      token = result.token;
      userId = result.userid;
    });

    switch (_type) {
      case "get":
        return await axios.get(_url, {
          headers: {
            "Content-Type": `application/json`,
            "Authorization": "Bearer " + token,
          },
          params: _params,
        });
      case "post":
        if (_bodys === null) {
          _bodys = _params;
        }

        return await axios.post(_url, _bodys, {
          headers: {
            "Content-Type": `application/json`,
            "Authorization": "Bearer " + token,
          },
          params: _params,
        });
      case "post1": //대용량 데이터 전송시 사용
        if (_bodys === null) {
          _bodys = _params;
        }

        return await axios.post(_url, _bodys, {
          headers: {
            "Content-Type": `application/json`,
            "Authorization": "Bearer " + token,
          },
          params: !_bodys ? _params : "",
        });
      case "file":
        if (_bodys === null) {
          _bodys = _params;
        }

        return await axios.post(_url, _bodys, {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Authorization": "Bearer " + token,
          },
          params: !_bodys ? _params : "",
        });
      case "fileDown":
        if (_bodys === null) {
          _bodys = _params;
        }

        return await axios.post(_url, _bodys, {
          headers: {
            "Content-Type": `application/json`,
            "Authorization": "Bearer " + token,
          },
          responseType: "blob",
          params: _params,
        });
      case "report":
        if (_bodys === null) {
          _bodys = _params;
        }
        return await axios.post(_url, _bodys, {
          headers: {
            "Content-Type": `application/json`,
            "Authorization": "Bearer " + token,
          },
          responseType: "blob",
          params: !_bodys ? _params : "",
        });
      case "login":
        return await axios.post(_url, _params, {
          Headers: {
            headers: { "Content-Type": `application/json` },
          },
          body: _params,
        });
      case "logout":
        window.localStorage.setItem(
          "auth",
          JSON.stringify({
            auth: false,
          })
        );
        await IndexedDb.ClearTable("LanInfo");
        await IndexedDb.ClearTable("MenuInfo");
        await IndexedDb.ClearTable("UserInfo");
      case "postOtherMultipart":
        // FormData 파일 업로드용 (Content-Type 직접 지정하지 않음)
        return await axios.post(_url, _bodys, {
          headers: {
            Authorization: "Bearer " + token,
          },
          params: _params,
        });
    }
  },

  // 비디오 및 오디오 요소 정리 함수
  cleanupMediaElements: function() {
    console.log("[Common] 미디어 요소 정리 시작");
    
    // ReactPlayer 관련 비디오만 정리 (더 안전한 방식)
    const reactPlayerVideos = document.querySelectorAll("[data-testid='react-player'] video");
    reactPlayerVideos.forEach((video, idx) => {
      console.log(`[Common] ReactPlayer video 태그 #${idx} 정리:`, video.src);
      try {
        // 비디오 정지 및 초기화
        video.pause();
        video.currentTime = 0;
        video.volume = 0;
        video.muted = true;
        video.src = "";
        video.srcObject = null;
        video.load();
        
        // 모든 이벤트 리스너 제거
        video.onplay = null;
        video.onpause = null;
        video.onended = null;
        video.onloadstart = null;
        video.onloadeddata = null;
        video.oncanplay = null;
        video.oncanplaythrough = null;
        video.onerror = null;
        video.onabort = null;
      } catch (e) {
        console.log(`[Common] ReactPlayer video 태그 #${idx} 정리 중 오류:`, e);
      }
    });
    
    // 일반 비디오 태그는 정지만 하고 제거하지 않음 (Main 페이지 등 보호)
    const allVideos = document.querySelectorAll("video");
    allVideos.forEach((video, idx) => {
      // ReactPlayer 비디오가 아닌 경우에만 정지
      if (!video.closest("[data-testid='react-player']") && !video.classList.contains('persist-video')) {
        console.log(`[Common] 일반 video 태그 #${idx} 정지:`, video.src);
        try {
          video.pause();
          video.currentTime = 0;
          video.volume = 0;
          video.muted = true;
        } catch (e) {
          console.log(`[Common] 일반 video 태그 #${idx} 정지 중 오류:`, e);
        }
      }
    });
    
    // ReactPlayer 내부 요소들 정리
    const reactPlayerElements = document.querySelectorAll("[data-testid='react-player']");
    reactPlayerElements.forEach((element, idx) => {
      console.log(`[Common] ReactPlayer 요소 #${idx} 정리`);
      try {
        const videoElement = element.querySelector("video");
        if (videoElement) {
          videoElement.pause();
          videoElement.currentTime = 0;
          videoElement.volume = 0;
          videoElement.muted = true;
          videoElement.src = "";
          videoElement.srcObject = null;
          videoElement.load();
        }
      } catch (e) {
        console.log(`[Common] ReactPlayer 요소 #${idx} 정리 중 오류:`, e);
      }
    });
    
    // 오디오 요소들 정리 (더 안전한 방식)
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audio, idx) => {
      console.log(`[Common] audio 태그 #${idx} 정리:`, audio.src);
      try {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = 0;
        audio.muted = true;
        // DOM에서 제거하지 않고 정지만 함
      } catch (e) {
        console.log(`[Common] audio 태그 #${idx} 정리 중 오류:`, e);
      }
    });
    
    // 브라우저 미디어 세션 완전 정리
    if ('mediaSession' in navigator) {
      try {
        // 모든 액션 핸들러 제거
        navigator.mediaSession.setActionHandler('play', null);
        navigator.mediaSession.setActionHandler('pause', null);
        navigator.mediaSession.setActionHandler('stop', null);
        navigator.mediaSession.setActionHandler('seekbackward', null);
        navigator.mediaSession.setActionHandler('seekforward', null);
        navigator.mediaSession.setActionHandler('seekto', null);
        navigator.mediaSession.setActionHandler('previoustrack', null);
        navigator.mediaSession.setActionHandler('nexttrack', null);
        navigator.mediaSession.setActionHandler('skipad', null);
        
        // 상태 초기화
        navigator.mediaSession.playbackState = 'none';
        navigator.mediaSession.metadata = null;
        
        // 추가적인 미디어 세션 정리
        if (navigator.mediaSession.setPositionState) {
          navigator.mediaSession.setPositionState(null);
        }
        
        // 빈 미디어 세션으로 덮어쓰기 (기존 세션 무효화)
        navigator.mediaSession.metadata = new MediaMetadata({
          title: '',
          artist: '',
          album: '',
          artwork: []
        });
        
        // 더미 액션 핸들러 설정 (아무것도 하지 않는 핸들러)
        const noopHandler = () => {};
        navigator.mediaSession.setActionHandler('play', noopHandler);
        navigator.mediaSession.setActionHandler('pause', noopHandler);
        navigator.mediaSession.setActionHandler('stop', noopHandler);
        
        // 즉시 정지 상태로 설정
        navigator.mediaSession.playbackState = 'paused';
        
      } catch (e) {
        console.log("[Common] 미디어 세션 정리 중 오류:", e);
      }
    }
    
    // Web Audio API 컨텍스트 정리
    try {
      if (window.audioContext) {
        window.audioContext.close();
        window.audioContext = null;
      }
    } catch (e) {
      console.log("[Common] Web Audio API 정리 중 오류:", e);
    }
    
    // 추가적인 미디어 스트림 정리
    try {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // 활성 미디어 스트림 정리
        const streams = document.querySelectorAll('video, audio');
        streams.forEach(stream => {
          if (stream.srcObject) {
            const tracks = stream.srcObject.getTracks();
            tracks.forEach(track => {
              track.stop();
            });
            stream.srcObject = null;
          }
        });
      }
    } catch (e) {
      console.log("[Common] 미디어 스트림 정리 중 오류:", e);
    }
    
    // 강제 가비지 컬렉션 요청 (브라우저가 지원하는 경우)
    if (window.gc) {
      try {
        window.gc();
      } catch (e) {
        console.log("[Common] 가비지 컬렉션 요청 중 오류:", e);
      }
    }
    
    console.log("[Common] 미디어 요소 정리 완료");
  },

  // 미디어 세션 완전 무효화 함수 (더 안전한 방식)
  disableMediaSession: function() {
    console.log("[Common] 미디어 세션 완전 무효화 시작");
    
    if ('mediaSession' in navigator) {
      try {
        // 현재 미디어 세션이 활성화되어 있는지 확인
        const hasActiveSession = navigator.mediaSession.metadata || 
                                navigator.mediaSession.playbackState !== 'none';
        
        if (!hasActiveSession) {
          console.log("[Common] 활성 미디어 세션이 없음 - 무효화 건너뜀");
          return;
        }
        
        // 모든 액션 핸들러를 더미 함수로 설정
        const noopHandler = () => {
          console.log("[Common] 미디어 세션 액션 무시됨");
          return false;
        };
        
        navigator.mediaSession.setActionHandler('play', noopHandler);
        navigator.mediaSession.setActionHandler('pause', noopHandler);
        navigator.mediaSession.setActionHandler('stop', noopHandler);
        navigator.mediaSession.setActionHandler('seekbackward', noopHandler);
        navigator.mediaSession.setActionHandler('seekforward', noopHandler);
        navigator.mediaSession.setActionHandler('seekto', noopHandler);
        navigator.mediaSession.setActionHandler('previoustrack', noopHandler);
        navigator.mediaSession.setActionHandler('nexttrack', noopHandler);
        navigator.mediaSession.setActionHandler('skipad', noopHandler);
        
        // 빈 메타데이터로 설정
        navigator.mediaSession.metadata = new MediaMetadata({
          title: '',
          artist: '',
          album: '',
          artwork: []
        });
        
        // 정지 상태로 설정
        navigator.mediaSession.playbackState = 'paused';
        
        // 위치 상태 초기화 (playbackRate는 0이 될 수 없음)
        if (navigator.mediaSession.setPositionState) {
          navigator.mediaSession.setPositionState({
            duration: 0,
            position: 0,
            playbackRate: 1
          });
        }
        
        console.log("[Common] 미디어 세션 완전 무효화 완료");
      } catch (e) {
        console.log("[Common] 미디어 세션 무효화 중 오류:", e);
      }
    }
  }
};

export default Commons;
